
import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';
import { policyImages } from '../../helpers/local-files';

const WhistleblowerEditor = () => {
  const columns = [
    { key: 'whistleblowing-en', label: 'Policy Name (EN)', type: 'text' },
    { key: 'whistleblowing-ms', label: 'Policy Name (MS)', type: 'text' },
    { key: 'description-en', label: 'Description (EN)', type: 'textarea' },
    { key: 'description-ms', label: 'Description (MS)', type: 'textarea' },
    { key: 'url', label: 'Image', type: 'image', suggestions: policyImages },
  ];

  return <GenericTableEditor tableName="whistleblower" columns={columns} title="Whistleblower Policy Manager" />;
};

export default WhistleblowerEditor;
